<article>
	<app-search-input [searchText]="searchFor()" (onSearchChanged)="searchChanged( $event)" tooltipText="Search" [resultCount]="resultCount()" />
</article>
